import React from "react";
import { FormProvider } from "react-hook-form";
import { Button, Callout, Card, Form, LoadingDots, Page } from "@sscs/ui";
import { InfoIcon, SaveIcon } from "@sscs/ui/icons";
import GroupMappingFields from "../../components/GroupMappingFields/GroupMappingFields";
import RestrictedAccess from "../../components/RestrictedAccess";
import { useGroupMappingForm } from "../../hooks";
import styles from "./groupMapping.module.scss";

const GroupMapping = () => {
  const { onSubmit, methods, isSaveDisabled, isLoading } =
    useGroupMappingForm();

  if (isLoading) return <LoadingDots />;

  return (
    <RestrictedAccess>
      <FormProvider {...methods}>
        <Page.Body>
          <Form.Form onSubmit={onSubmit} className={styles.form}>
            {!isSaveDisabled && (
              <Page.FloatingActions>
                <Callout
                  type="error"
                  title="You have unsaved changes"
                  variant="inline"
                />
                <Button type="submit" color="primary" disabled={isSaveDisabled}>
                  <SaveIcon />
                  Save
                </Button>
              </Page.FloatingActions>
            )}
            <Card.Card>
              <Card.Title>SSO group mapping</Card.Title>
              <Card.Content className={styles["group-mapping-form"]}>
                <small className={styles["info-flex"]}>
                  <InfoIcon />
                  Group names are required. You must map each SSO group to a
                  Spectra Assure group.
                </small>
                <GroupMappingFields />
              </Card.Content>
            </Card.Card>
          </Form.Form>
        </Page.Body>
      </FormProvider>
    </RestrictedAccess>
  );
};

export default GroupMapping;
